<template>
  <div class="countdown_to_next_event_container">
    
    <!-- COUNTDOWN
    11/05/2018 12:00 AM UTC-0400
     -->
    <countdown
    v-if="event_data_needed != '' && event_data_needed != 'Event has ended'"
    :target_date="countdown_date"
    :title="countdown_title"
    ></countdown>
    
  </div>
</template>

<script>
import Countdown from './countdown_timer.vue';

export default {
  name: 'countdown_to_next_event',
  props: [
    
  ],
  data () {
    return {
      countdown_title: '',
      countdown_date: '',
      event_data_needed: '',
      event_property_needed: 'start'
    }
  },
  computed: {
    master_instance_periods: function() {
      return this.$root.store.instances.state.instance_periods;
    },  
    instance_period: {
      get: function() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    tz_offset: function() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    active_instance_updated: function() {
      return this.$root.store.instances.state.active_instance_updated;
    }
  },
  methods: {
    get_period_data: function(period) {
      return this.$root.store.instances.get_specific_instance_period(period);
    },
    check_for_instance_data: function(callback) {
      let vm = this;

      if(vm.active_instance_updated == true && vm.master_instance_periods.length > 0) {
        callback();
      }
      else {
        setTimeout(function() {
          vm.check_for_instance_data(callback);
        }, 200);
      }
    },
    determine_countdown_values: function() {
      let vm = this;
      
      // DETERMINE THE NEXT COUNTDOWN EVENT
      switch(vm.instance_period) {
        case 'Event not started':
          vm.event_data_needed = 'Nomination Period';
          vm.event_property_needed = 'start';
          vm.countdown_title = 'Nominations start in:';
          break;

        case 'Nomination Period':
          vm.event_data_needed = 'Nomination Period';
          vm.event_property_needed = 'stop';
          vm.countdown_title = 'Nominations end in:';
          break;

        case 'Nomination Intermission':
          vm.event_data_needed = 'Voting Period';
          vm.event_property_needed = 'start';
          vm.countdown_title = 'Voting starts in:';
          break;

        case 'Voting Period':
          vm.event_data_needed = 'Voting Period';
          vm.event_property_needed = 'stop';
          vm.countdown_title = 'Voting ends in:';
          break;

        case 'Voting Intermission':
          vm.event_data_needed = 'Winners Period';
          vm.event_property_needed = 'start';
          vm.countdown_title = 'Winners announced in:';
          break;

        default:
          vm.event_data_needed = 'Event has ended';
          break;
      }

      // DETERMINE COUNTDOWN DATE/TIME
      if(vm.event_data_needed != 'Event has ended' && vm.event_data_needed != '') {
        let period_data = vm.get_period_data(vm.event_data_needed);
        let target_date = this.$root.store.manipulation_helpers.get_human_datetime(period_data[vm.event_property_needed], vm.tz_offset);

        // console.log('target_date: ', target_date);

        vm.countdown_date = target_date;
      }
    }
  },
  watch: {

  },
  mounted() {
    this.check_for_instance_data(this.determine_countdown_values);
  },
  components: {
    Countdown
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/features/countdown/countdown_to_next_event.vue